import { setInitializedMap } from './setInitializedMap';

export const mapOperations = {
  setInitializedMap
};
